import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ErrorIcon from '@material-ui/icons/Error';
import { useSelector } from 'react-redux';
import { checkDoShowAgentCommission } from '../../../../../store/slices/user';
import currencySymbol from '../../../../../helpers/currencySymbol';
import { TravelTypes } from '../../../../../constants';
import getCommissionLabel from '../../../../../helpers/getCommissionLabel';
import Label from '../../../../Label';

const AgentCommission = ({
  agentCommission,
  isCommissionable,
  className,
  currencyCode,
  agentCommissionPercentage,
  doShowCommissionAsPercentage,
}) => {
  const { travelAgency } = useSelector((store) => store.user);

  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  if (!doShowAgentCommission) {
    return <></>;
  }

  const NON_COMMISSIONABLE_TOOLTIP = 'No advisor commission is paid on this booking option.';
  // const COMMISSIONABLE_TOOLTIP = 'Commission will be earned on this booking.';

  const shouldShowPercentage = doShowCommissionAsPercentage && agentCommissionPercentage > 0;

  const showNonCommissionablePill = !agentCommission && isCommissionable === false;

  return isCommissionable !== null ? (
    <div
      className={clsx(
        className,
        showNonCommissionablePill && 'inline-flex max-w-full align-middle',
      )}
    >
      {agentCommission ? (
        <>
          <span>
            {getCommissionLabel(travelAgency, TravelTypes.hotel)}
            {': '}
          </span>
          {shouldShowPercentage ? (
            <NumberFormat
              value={agentCommissionPercentage}
              displayType="text"
              decimalScale="1"
              suffix="%"
            />
          ) : (
            <NumberFormat
              value={agentCommission}
              prefix={currencySymbol(currencyCode)}
              displayType="text"
              thousandSeparator
              fixedDecimalScale="true"
              decimalScale="2"
            />
          )}
        </>
      ) : (
        <>
          {isCommissionable ? (
            <span>Commissionable</span>
          ) : (
            <Label
              text="Non-commissionable"
              icon={
                <ErrorIcon
                  className="text-white flex-shrink-0"
                  style={{ fontSize: '1rem', display: 'block' }}
                />
              }
              inline={false}
              level=""
              className="inline-flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 whitespace-nowrap text-sm font-semibold leading-tight text-white max-w-full"
              descriptionOnHover={NON_COMMISSIONABLE_TOOLTIP}
            />
          )}
        </>
      )}
    </div>
  ) : (
    <></>
  );
};

AgentCommission.propTypes = {
  agentCommission: PropTypes.number,
  isCommissionable: PropTypes.bool,
  className: PropTypes.string,
  currencyCode: PropTypes.string,
  agentCommissionPercentage: PropTypes.number,
  doShowCommissionAsPercentage: PropTypes.bool,
};

AgentCommission.defaultProps = {
  className: '',
  isCommissionable: null,
  agentCommission: null,
  currencyCode: undefined,
  agentCommissionPercentage: null,
  doShowCommissionAsPercentage: false,
};

export default AgentCommission;
